import React from "react";
import Navbar from "../components/Navbar";

const PrivacyPolicy = () => {
  return (
    <main>
      <Navbar />
      <div className="container my-5">
        <div className="card shadow-sm">
          <div className="card-header bg-primary text-white">
            <h1 className="h3 mb-0">Privacy Policy</h1>
          </div>
          <div className="card-body">
            <h2>1. Introduction</h2>
            <p>
              Welcome to the <b>Nuprex Limited</b> mobile app. We are committed to
              protecting your privacy and ensuring that your personal
              information is handled in a safe and responsible manner. This
              Privacy Policy outlines how we collect, use, and protect the
              information you provide when you sign up and use our mobile app.
            </p>

            <h2>2. Information We Collect</h2>
            <p>
              When you sign up on our mobile app, we may collect the following
              types of information:
            </p>
            <ul>
              <li>
                <strong>Personal Information:</strong> Name, email address,
                phone number, mailing address, and other contact details.
              </li>
              <li>
                <strong>Account Information:</strong> Username, password, and
                preferences or settings configured within the app.
              </li>
              <li>
                <strong>Device Information:</strong> Information about the
                device you use to access our app, such as device type, operating
                system, and unique device identifiers.
              </li>
              <li>
                <strong>Usage Data:</strong> Information about how you use the
                app, including interactions, session duration, and accessed
                pages or features.
              </li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>
              The information we collect may be used for the following purposes:
            </p>
            <ul>
              <li>
                <strong>Account Creation and Management:</strong> To create and
                manage your account, provide customer support, and communicate
                with you.
              </li>
              <li>
                <strong>Service Delivery:</strong> To deliver services such as
                order processing, shipment tracking, and customer service.
              </li>
              <li>
                <strong>App Improvement:</strong> To analyze usage patterns and
                improve app functionality and user experience.
              </li>
              <li>
                <strong>Marketing and Communication:</strong> To send you
                promotional materials and updates, if you opt-in.
              </li>
              <li>
                <strong>Legal Compliance:</strong> To comply with applicable
                laws and regulations.
              </li>
            </ul>

            <h2>4. Sharing Your Information</h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal
              information to third parties, except in the following
              circumstances:
            </p>
            <ul>
              <li>
                <strong>Service Providers:</strong> We may share your
                information with trusted third-party service providers who
                assist us in operating our app, conducting our business, or
                providing services to you, so long as those parties agree to
                keep this information confidential.
              </li>
              <li>
                <strong>Legal Requirements:</strong> We may disclose your
                information if required by law, court order, or governmental
                regulation.
              </li>
            </ul>

            <h2>5. Data Security</h2>
            <p>
              We implement a variety of security measures to protect your
              personal information. Your information is stored on secure
              servers, and we employ encryption and other technologies to ensure
              the safe transmission of data. However, no method of transmission
              over the internet or electronic storage is completely secure, and
              we cannot guarantee absolute security.
            </p>

            <h2>6. Your Rights</h2>
            <ul>
              <li>
                <strong>Access Your Information:</strong> Request a copy of the
                personal data we hold about you.
              </li>
              <li>
                <strong>Update Your Information:</strong> Correct or update any
                of your personal information.
              </li>
              <li>
                <strong>Delete Your Information:</strong> Request the deletion
                of your personal information from our systems, subject to
                certain legal obligations.
              </li>
              <li>
                <strong>Opt-Out:</strong> Opt-out of receiving marketing
                communications from us at any time.
              </li>
            </ul>

            <h2>7. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page, and the revised policy will indicate
              the date it was last updated. We encourage you to review this
              Privacy Policy periodically to stay informed about how we protect
              your information.
            </p>

            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our data
              practices, please contact us at:
            </p>
            <address>
              <strong>Nuprex Limited</strong>
              <br />
              3rd Floor, Unit 8/9, Building 1, View Point Plaza, Nepa Road,
              Ajah, Lagos
              <br />
              Email: <a href="mailto:info@nuprex.com.ng">info@nuprex.com.ng</a>
              <br />
              Phone: <a href="tel:02018880243">02018880243</a>
            </address>
          </div>
        </div>
      </div>
      
    </main>
  );
};

export default PrivacyPolicy;
